module.exports = __webpack_public_path__ + "static/ib-e3039c9ded506ace3629c1f86cd0e7dc.svg";